import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { useStore } from "vuex";
import useApplicationData from "@/composables/useApplicationData";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreditAvailabilityNotice',
  setup(__props) {

useStore();

const { emailAddress } = useApplicationData();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", null, [
    _cache[0] || (_cache[0] = _createTextVNode(" The maximum line of credit amount below will be available while you are pursuing your degree. If you don't need the full amount now, it will remain available until you separate from school. If you would like to reduce your Line of Credit limit, please reach out to our processing team at ", -1)),
    _createElementVNode("a", {
      class: "email-link",
      href: `mailto:${_unref(emailAddress)}`
    }, _toDisplayString(_unref(emailAddress)), 9, _hoisted_1),
    _cache[1] || (_cache[1] = _createTextVNode(". ", -1))
  ]))
}
}

})